import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-page-hero-with-boxes',
    templateUrl: './one-page-hero-with-boxes.component.html',
    styleUrls: ['./one-page-hero-with-boxes.component.scss'],
    standalone: false
})

export class OnePageHeroWithBoxesComponent extends BlockAbstractComponent implements OnInit {
    heroTitle = "Bally&nbsp;Group Pension Scheme"
    heroParagraphs = [
        "The Trustees are responsible for ensuring that the Scheme is run in accordance with the Scheme's rules, and UK pensions and tax law.",
        "To do so we need to provide members with certain accessible information on the Scheme, which can be found on this site."
    ]

    memberPortalTitle = 'Member portal'
    memberPortalText = 'Lorem ipsum dolor sit amet consectetur. Donec imperdiet felis at volutpat. Ultrices urna ipsum placerat integer.'
    memberPortalButtonText = 'Take me to the Member Portal'

    contactDetailsTitle = "Contact details"
    contactDetailsTelephone = "0330 678 0166"
    contactDetailsEmailHref = "mailto:totalbenefits@buck.com"
    contactDetailsEmailText = "totalbenefits@buck.com"
    contactDetailsAddress = "Buck, PO Box 324, Mitcheldean, GL14 9BJ"
}
